const loaded = new Set();

export async function loadFont(family, url) {
  if (!family || !url || loaded.has(family)) return;
  try {
    const font = new FontFace(family, `url("${url}")`);
    await font.load();
    document.fonts.add(font);
    loaded.add(family);
  } catch (err) {
    console.error(`Could not load font ${family}:`, err);
  }
}